/*
 * @Date: 2019-07-22 09:59:17
 * @LastEditTime: 2020-12-24 20:04:43
 * @LastEditors: hai.zhang
 */
import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user/index'
import bar from './modules/bar/index'
Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    user,
    bar
  }
})

export default store



// WEBPACK FOOTER //
// ./src/vuex/index.js